import { Button, Result } from 'antd'
import { useNavigate } from 'react-router-dom'

import { useLocales } from 'src/locales'
import { paths } from 'src/paths'

export const RestrictedAccess = () => {
  const { t } = useLocales()
  const navigate = useNavigate()

  return (
    <Result
      status="403"
      title="403"
      subTitle={t('restricted_access.title')}
      extra={
        <Button
          type="primary"
          size="large"
          onClick={() => navigate(paths.root)}
        >
          {t('restricted_access.back_home')}
        </Button>
      }
    />
  )
}
